import { renderer, substituteMappedValues } from '@integrations/contentful/contentful.utils';
import { ContentBlock, ContentBlockRendered, MetaData } from '@scenes/LocationPage/locationPage.types';
import { IHash } from 'types/base.types';

type GenerateDynamicDataProps<T> = {
  seedData: Partial<T>;
  mapper: IHash<string>;
};

export const generateDynamicMetaData = ({ seedData, mapper }: GenerateDynamicDataProps<MetaData>) =>
  ({
    description: substituteMappedValues(seedData.description!, mapper),
    title: substituteMappedValues(seedData.title!, mapper),
  }) as MetaData;

export const generateDynamicContentData = ({ seedData, mapper }: GenerateDynamicDataProps<ContentBlock>) =>
  ({
    contentOneTitle: substituteMappedValues(seedData.contentOneTitle, mapper),
    contentOneBody: renderer(seedData.contentOneBody!.json, mapper),
    contentTwoTitle: substituteMappedValues(seedData.contentTwoTitle, mapper),
    contentTwoBody: renderer(seedData.contentTwoBody!.json, mapper),
    contentThreeTitle: substituteMappedValues(seedData.contentThreeTitle, mapper),
    contentThreeBody: seedData.contentThreeBody ? renderer(seedData.contentThreeBody.json, mapper) : '',
  }) as ContentBlockRendered;
